import React from "react";

const FAQSection: React.FC = () => {
  const faqs = [
    {
      question: "How do I upload and arrange my images?",
      answer:
        "Simply drag and drop images into the layout tool. You can reposition, resize, and label them effortlessly.",
    },
    {
      question: "Can I export in PDF and PNG formats?",
      answer:
        "Yes! The tool supports high-resolution PDF and PNG exports for print or digital use.",
    },
    {
      question: "Is this tool suitable for non-designers?",
      answer:
        "Absolutely. It’s built with simplicity in mind, so anyone can create polished layouts in minutes.",
    },
    {
      question: "Can I save and edit my layout later?",
      answer:
        "Yes, you can save your layout and return to it anytime without losing your progress.",
    },
    {
      question: "What image formats are supported?",
      answer:
        "You can upload JPEG, PNG, and GIF images for merging.",
    },
    {
      question: "Is the tool really free?",
      answer:
        "Yes! 100% free with no sign-up or hidden costs.",
    },
  ];

  return (
    <section className="w-full py-24 bg-gradient-to-br from-[#f5f7fa] via-[#edf2f7] to-[#e2e8f0] rounded-3xl shadow-inner overflow-hidden relative">
      {/* Glowing accents */}
      <div className="absolute top-[-5rem] right-[-5rem] w-72 h-72 bg-blue-300 opacity-20 blur-3xl rounded-full z-0 animate-pulse"></div>
      <div className="absolute bottom-[-4rem] left-[-4rem] w-52 h-52 bg-purple-300 opacity-20 blur-3xl rounded-full z-0 animate-pulse"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 md:px-12">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-6 tracking-tight">
          Frequently Asked Questions
        </h2>
        <p className="text-lg text-center text-gray-600 max-w-2xl mx-auto mb-14">
          We've answered some common questions to help you get started smoothly and confidently.
        </p>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-[#5662e733] backdrop-blur-xl rounded-2xl p-6 border border-white/20 shadow-md transition hover:shadow-lg"
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
